module.exports = __webpack_public_path__ + "static/media/shipping-choko.459efb64.png";